export default "__VITE_ASSET__5840da38__"